module.exports = __webpack_public_path__ + "media/images/athletes/4251-95e2c837b0baf11622c93e37aacc91aa.png";